import videojs from 'video.js';
import 'videojs-xr';
import 'videojs-xr/dist/videojs-xr.css';
import './video360.css';
import { QueryStringParamProvider } from 'PLAYER_SRC/implementations/player-page/helpers.js';

export class Video360PluginStub extends videojs.getPlugin('plugin') {
    constructor(player, options) {
        super(player, options);

        player.loader().onLoadPresentation(onLoadPresentation.bind(player));
    }
}

function shouldLoad(presentationId, playCoverData, presentationData) {
    const paramProvider = new QueryStringParamProvider(location.search);
    const disableOverlays = (paramProvider.getParam('DisableInteractiveOverlays')?.toLowerCase() === 'true');
    return presentationData.metadata.is360Video && !disableOverlays;
}

async function onLoadPresentation(presentationId, playCoverData, presentationData) {
    const player = this;

    if (shouldLoad(...arguments)) {
        player.xr();

        if (!videojs.getPlugin('video360')) {
            const { Video360Plugin } = await import(/* webpackChunkName: 'video360' */ './video360.js');
            player.registerPlugin('video360', Video360Plugin);
        }

        player.video360().init();
    }
}